<template>
  <div id="app">
    <v-app>
      <!-- Auth -->
      <v-container>
        <p class="text-h5">Auth</p>
        <v-row class="ml-4"> {{ authText }}</v-row>
        <v-row class="mt-4 ml-4">
          <v-btn color="accent" @click="authStart"> auth 開始 </v-btn>
        </v-row>
      </v-container>

      <!-- LIFF -->
      <v-container>
        <p class="text-h5">LIFF 実験</p>
        <v-row class="mt-4 ml-4">
          <v-btn color="accent" @click="closeLiff"> close </v-btn>
        </v-row>
      </v-container>

      <!-- ふきだし -->
      <v-container>
        <p class="text-h5">ふきだし実験</p>
        <div class="line-bg line-bc" style="padding: 16px">
          <div class="mycomment">
            <p>右ふきだし文<br />aaaa</p>
          </div>

          <div class="balloon6">
            <div class="faceicon">
              <img :src="iconUrl" />
            </div>

            <div class="chatting">
              <div class="says">
                <p>左ふきだし文ああああ</p>
              </div>
            </div>
            <div class="chatting" style="margin-top: 8px">
              <div class="says">
                <p>左ふきだし文ああああ<br />aaa</p>
              </div>
            </div>
          </div>
        </div>

        <div style="border: solid; padding: 16px">
          <div class="balloon6">
            <div class="faceicon">
              <img :src="iconUrl" />
            </div>

            <div class="chatting">
              <div class="says-border">
                <span>左ふきだし文ああああ</span>
              </div>
            </div>
            <div class="chatting">
              <div class="says-border">
                <span>左ふきだし文ああああ<br />aaa</span>
              </div>
            </div>
          </div>
        </div>
      </v-container>

      <!-- bottom sheet -->
      <v-container>
        <v-bottom-sheet v-model="sheet">
          <v-sheet class="text-center" height="200px">
            <p class="py-3">
              <span>{{ sheetText }}</span>
            </p>
            <v-btn class="mt-6" text color="red" @click="sheet = !sheet"
              >close</v-btn
            >
          </v-sheet>
        </v-bottom-sheet>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { liffReady, sendMessages, closeWindow } from "../../util/liff_util";
const IMG_NOBUNAGA =
  "https://storage.googleapis.com/avt-nobunaga-261b3.appspot.com/thumbs/nobunaga_200x200.png";

export default {
  data: () => ({
    authText: "ログイン未",
    // bottom sheet
    sheet: false,
    sheetText: "",
    doAnimate: false,
    // カートアイコン
    resourcePath: "",
    cartItemSize: 0,
    // アイコン
    iconUrl: IMG_NOBUNAGA,
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "DEBUG";
    this.$store.state.cart = false;
    this.$store.state.progress = false;
  },
  async mounted() {
    await liffReady(); // LIFF 初期化待機
    this.hideProgress();

    this.changeCartIcon();
  },
  computed: {
    // ...mapGetters(["progress"]),
    // カートアイコン
    classCartIcon: function () {
      return {
        // animate.css (https://animate.style/)
        animate__bounceInUp: this.doAnimate,
      };
    },
  },
  methods: {
    ...mapActions(["hideProgress"]),
    ...mapActions("rest", ["testAuth"]),
    authStart: async function () {
      this.authText = "ログイン中...";
      await this.testAuth();
      this.authText = "ログイン済";
    },
    addToCart: function () {
      // アイコン切替 (カートに追加)
      this.cartItemSize++;
      this.changeCartIcon();
      this.doAnimate = true;
    },
    clearCart: function () {
      this.cartItemSize = 0;
      this.changeCartIcon();
    },
    animationEnd: function () {
      this.doAnimate = false;
    },
    changeCartIcon: function () {
      if (this.cartItemSize == 0) {
        this.resourcePath = require("@/assets/cart-empty-outline-300.svg");
      } else {
        this.resourcePath = require("@/assets/cart-in-outline-300.svg");
      }
    },
    closeLiff: async function () {
      // LIFF 閉じる
      closeWindow();
    },
    sendMessages: async function (messages) {
      // トークへメッセージ送信
      await sendMessages(messages).catch((e) => {
        // snackbar 表示
        console.log(e);
        this.sheetText = e;
        this.sheet = true;
      });
    },
  },
};
</script>

<style>
@import "../../css/bubble.css";
</style>
